
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    name: String,
    icone: String,
    idIcon: String,
    titulo: String,
    valor: String,
    dia: String,
    paymentMethodName: String,
    infoAdicional: String,
    status: String,
    click: Function,
  },
})
export default class ThreeOptionsListExtract extends Vue {
  pedido: any = true;

  iconColorExtrato(idIcon: any, status: any) {}
}
